class notificacoesModel {
  constructor() {
    this.id = "",
    this.processo_id = "",
    this.dt_notificacao = "",
    this.hr_notificacao = "",
    this.ds_notificacao = "",
    this.usuarioorigem_id = "",
    this.usuariodestino_id = "",
    this.dataString = "",
    this.horanotiftela = ""

  }
}

export default notificacoesModel


// WEBPACK FOOTER //
// ./src/views/Notificacoes/_model/index.js